import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useSetSearchParams() {
    const [searchParams, setSearchParams] = useSearchParams();

    const setParams = useCallback(
        (obj: Record<string, string>) => {
            Object.entries(obj).forEach(([key, value]) => {
                // searchParams.set(key, value);
                searchParams.set(key, value.replace(/ /g, '%20'));
            });
            setSearchParams(searchParams);
        },
        [searchParams, setSearchParams]
    );

    return setParams;
}
